module.exports = __webpack_public_path__ + "img/invitation.005be9c5.png";